import React, { useEffect, useState } from 'react';
import { Text } from 'shared-components';
import { TentoZ } from '@components/BCMShort/WizardShell';
import { LoanWizardShell } from './LoanWizardShell';

interface LoanSubmittingOverlayProps {
  label?: string;
  currentStepIndex?: number;
  brandLabel?: string;
}

// Full-page submitting state for any loan-flow API submit. Mirrors the
// BCM-Short submitting overlay (spinning Tento "Z" + animated dots) so the
// two flows behave identically during long-running submits.
export const LoanSubmittingOverlay: React.FC<LoanSubmittingOverlayProps> = ({
  label = 'SUBMITTING YOUR APPLICATION',
  currentStepIndex = 0,
  brandLabel,
}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + '.' : ''));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <LoanWizardShell currentStepIndex={currentStepIndex} brandLabel={brandLabel} isSubmitting>
      <div className="flex flex-col gap-[20px] items-center justify-center w-full h-full">
        <div className="h-[59px] w-[60px]">
          <TentoZ className="animate-spin2x" />
        </div>
        <div className="flex gap-[10px] items-center justify-center py-[20px] w-full">
          <Text variant="headline-sm" className="!font-extended !uppercase !text-[16px] !leading-none text-center">
            {label}
            <span className="inline-block min-w-[12px] text-left">{dots}</span>
          </Text>
        </div>
      </div>
    </LoanWizardShell>
  );
};
